/**
 * Api Portal AutoAtendimento
 * AutoAtendimento
 *
 * OpenAPI spec version: v1
 * Contact: helpdesk@sicred.com
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *
 */


import ApiClient from '../ApiClient';





/**
* The SicredErrorResponse model module.
* @module model/SicredErrorResponse
* @version v1
*/
export default class SicredErrorResponse {
    /**
    * Constructs a new <code>SicredErrorResponse</code>.
    * @alias module:model/SicredErrorResponse
    * @class
    */

    constructor() {
        

        
        

        

        
    }

    /**
    * Constructs a <code>SicredErrorResponse</code> from a plain JavaScript object, optionally creating a new instance.
    * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
    * @param {Object} data The plain JavaScript object bearing properties of interest.
    * @param {module:model/SicredErrorResponse} obj Optional instance to populate.
    * @return {module:model/SicredErrorResponse} The populated <code>SicredErrorResponse</code> instance.
    */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new SicredErrorResponse();

            
            
            

            if (Object.prototype.hasOwnProperty.call(data, 'code')) {
                obj['code'] = ApiClient.convertToType(data['code'], 'Number');
            }
            if (Object.prototype.hasOwnProperty.call(data, 'field')) {
                obj['field'] = ApiClient.convertToType(data['field'], 'String');
            }
            if (Object.prototype.hasOwnProperty.call(data, 'message')) {
                obj['message'] = ApiClient.convertToType(data['message'], 'String');
            }
        }
        return obj;
    }

    /**
    * @member {Number} code
    */
    code = undefined;
    /**
    * @member {String} field
    */
    field = undefined;
    /**
    * @member {String} message
    */
    message = undefined;








}


